import React from 'react';
import { Link } from 'react-router-dom';
import frocortLogo from '../assets/frocort-logo-navbar.svg';

const Footer = () => {
  return (
      <footer className="relative overflow-hidden border-t border-white/10 bg-[#05070b] text-white">

        <div className="mx-auto max-w-[1400px] px-8 py-12">

          {/* Footer navigation */}
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">

            {/* Brand */}
            <div>
              <Link
                  to="/"
                  aria-label="FroCort home"
                  className="flex items-center"
              >
                <img
                    src={frocortLogo}
                    alt="FroCort"
                    className="h-auto w-[130px]"
                />
              </Link>

              <p className="mt-3 max-w-[240px] text-[12px] leading-5 text-neutral-600">
                Cognitive intelligence software for the next
                generation of wearables.
              </p>
            </div>

            {/* Explore */}
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-600">
                Explore
              </div>

              <div className="mt-4 flex flex-col gap-2.5 text-[13px] text-neutral-400">

                <Link
                    to="/"
                    className="transition-colors hover:text-white"
                >
                  Home
                </Link>

                <Link
                    to="/technology"
                    className="transition-colors hover:text-white"
                >
                  Technology
                </Link>

                <Link
                    to="/research"
                    className="transition-colors hover:text-white"
                >
                  Research
                </Link>

                <Link
                    to="/for-device-makers"
                    className="transition-colors hover:text-white"
                >
                  For device makers
                </Link>

                <Link
                    to="/vision"
                    className="transition-colors hover:text-white"
                >
                  Vision
                </Link>

              </div>
            </div>

            {/* Company */}
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-600">
                Company
              </div>

              <div className="mt-4 flex flex-col gap-2.5 text-[13px] text-neutral-400">

                <Link
                    to="/#contact"
                    className="transition-colors hover:text-white"
                >
                  Contact
                </Link>

              </div>
            </div>

            {/* Current focus */}
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-600">
                Current focus
              </div>

              <div className="mt-4 text-[12px] leading-5 text-neutral-500">
                Evaluated ML model
                <br />
                ↓
                <br />
                Working live-EEG prototype
                <br />
                ↓
                <br />
                Human validation
              </div>
            </div>

          </div>

          {/* Bottom */}
          <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-5 text-[10px] text-neutral-700 sm:flex-row sm:items-center sm:justify-between">

                    <span>
                        © {new Date().getFullYear()} FroCort. All rights reserved.
                    </span>

            <a
                href="mailto:contact@frocort.com"
                className="transition-colors hover:text-neutral-400"
            >
              contact@frocort.com
            </a>

          </div>

        </div>
      </footer>
  );
};

export default Footer;